import {
  Box,
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import useTranslate from "hooks/useTranslate";
import TraitTile from "components/TraitTile";
import { SwiperSlide } from "swiper/react/swiper-react";
import { Controller } from "swiper";
import BeforeAfterPreview from "components/BeforeAfterPreview";
import useApplyTraitChanges from "hooks/useApplyTraitsChanges";
import ControlledSwiper from "components/ControlledSwiper";
import useTraits from "hooks/useTraits";

type StakePopupProps = Omit<ModalProps, "children"> & {
  newTraits: number[];
  initialTraits: number[];
  tokenId: number;
  color: number;
};

const StakePopup = ({
  tokenId,
  color,
  newTraits,
  initialTraits,
  ...rest
}: StakePopupProps) => {
  const translate = useTranslate();
  const { traitsMap } = useTraits();
  const isMultiple = newTraits.length > 1;

  const slidesPerView = isMultiple ? 1.35 : 1;

  const applayedTraits = useApplyTraitChanges(initialTraits, newTraits);

  return traitsMap ? (
    <Modal {...rest}>
      <ModalOverlay />
      <ModalContent w="sm" maxH="calc(100vh - 4rem)" mt="2rem" mb="2rem">
        <ModalCloseButton />

        <ModalBody
          py="8"
          px="0"
          display="flex"
          flexDir="column"
          maxH="full"
          overflow="auto"
        >
          <VStack w="full" pt="4" spacing="6" align="stretch">
            <Box px="12">
              <Heading
                fontSize="2xl"
                fontWeight="bold"
                textAlign="center"
                mb="3"
              >
                {translate(
                  isMultiple ? "stake:title:multi" : "stake:title:single",
                  { count: newTraits.length }
                )}
              </Heading>

              <Text fontSize="sm" opacity="0.8" textAlign="center">
                {translate("stake:description")}
              </Text>
            </Box>

            <Box px="6">
              <BeforeAfterPreview
                oldTraits={initialTraits}
                newTraits={applayedTraits}
                color={color}
                imagesSize="256"
                bg="dark.400"
              />
            </Box>

            <ControlledSwiper
              spaceBetween={2}
              threshold={10}
              modules={[Controller]}
              slidesPerView={slidesPerView}
              freeMode
            >
              {newTraits.map((tokenId) => (
                <SwiperSlide key={tokenId}>
                  <TraitTile
                    tokenId={tokenId}
                    name={traitsMap[tokenId].name}
                    color={color}
                    px="6"
                    w="full"
                    canvasSize="12"
                    bg="dark.600"
                  />
                </SwiperSlide>
              ))}
            </ControlledSwiper>
          </VStack>

          <Box px="6" pt="6">
            <Button w="full">{translate("stake:submit")}</Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  ) : null;
};

export default StakePopup;
